import { Item } from 'app/services/itemsSearchService';
import { EcoTaxResponse } from 'app/services/ecoTaxService/ecoTaxService.types';
import { formatDate } from './utils/formatDate';

export interface ReadOnlyItemForm {
  itemId: string;
  name: string;
  unitOfMeasure: string;
}

export type EditableItemForm = {
  quantity: string;
  unitPrice: string;
  totalPrice: string;
}

type CorrelationId = {
  correlationId?: string;
}

export type EcoTaxItems = {
  ecoTaxItems: Array<EcoTaxResponse & EditableItemForm & CorrelationId>;
}

export type DialogFormData = EditableItemForm & Item & EcoTaxItems & CorrelationId;

export type VATSummary = {
  basePrice: string;
  VATAmount: string;
  taxableGroupId: string;
};

export type CustomerInformation = {
  taxId: string;
  name: string;
  country: string;
  zipCode: string;
  city: string;
  address1: string;
  address2: string;
};

export const CUSTOMER_INFORMATION_DEFAULT_VALUES: Record<keyof CustomerInformation, string> = {
  taxId: '',
  name: '',
  country: 'PT',
  zipCode: '',
  city: '',
  address1: '',
  address2: '',
};

export const DEFAULT_RECEIPT_VALUES = {
  lineItems: [],
  VATSummary: [],
  grossTotal: '',
  referencedFiscalNumber: '',
  invoiceDate: formatDate(),
  customer: CUSTOMER_INFORMATION_DEFAULT_VALUES,
};

export type LineItem = {
  uuid: string;
  item: DialogFormData;
};

export type ReceiptFormData = {
  lineItems: LineItem[];
  VATSummary: VATSummary[];
  referencedFiscalNumber: string;
  invoiceDate: string;
  grossTotal: string;
  customer?: CustomerInformation;
};
